/**
 * O nome de um grupo de WhatsApp, para a tela.
 *
 * ⚠️ Mora fora do componente porque **arquivo que exporta componente não pode
 * exportar função** — o fast refresh do Vite deixa de funcionar, e o lint do
 * projeto trata isso como erro. Foi o gate que cobrou.
 */
import type { Grupo } from './GruposDoWhatsApp';

/**
 * 🔴 O nome da **Evolution** vem primeiro: é o que aparece no WhatsApp, e é o
 * que o Matheus reconhece ao conferir um vínculo. O rótulo do sistema antigo é
 * reserva, e o id é o último recurso.
 */
export function nomeDoGrupo(g: Grupo): string {
  return g.nomeNaEvolution ?? g.nomeNoV1 ?? g.grupoId;
}
